import TableButton from 'components/common/Buttons/TableButton'
import Table from 'components/common/Table'
import { MediatorContext } from 'context/MediatorContext'
import React, { useContext, useState } from 'react'
import Accounts from '../Accounts'

const SEARCH_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
  'companyName',
]
const ORDER_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
  'companyName',
]

const Clients = () => {
  const { clients } = useContext(MediatorContext)

  const [selectedClient, setSelectedClient] = useState(null)
  const aditionalColumns = [
    {
      Header: 'Empleados',
      Cell: ({
        row: {
          original: {
            id, accounts, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData?.id}
            clickHandler={() =>
              setSelectedClient((ps) =>
                ps?.id === id
                  ? null
                  : {
                    endpoint: accounts,
                    title: `${firstName} ${lastName}`,
                    id,
                  })}
          >
            Ver Empleados
          </TableButton>
        )
      },
    },
  ]
  return (
    <Table
      title='Mis Empresas'
      endpoint='/mediators/clients'
      tableData={clients}
      aditionalColumns={aditionalColumns}
      searchOptions={SEARCH_OPTIONS}
      orderOptions={ORDER_OPTIONS}
      cellCustomData={selectedClient}
      disableAutoScroll
    >
      {selectedClient && <Accounts client={selectedClient} />}
    </Table>
  )
}

export default Clients
